/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { ActionLinkColumn, ColumnTexts } from '@veeam-vspc/components';

import { SourceItemsDialog } from './components/SourceItemsDialog/SourceItemsDialog';

import type { SourceItemsDialogProps } from './components/SourceItemsDialog/SourceItemsDialog';

export interface SourceItemsColumnProps extends Omit<SourceItemsDialogProps, 'deactivate'> {
    value: string | null;
    alignRight?: boolean;
}

export const SourceItemsColumn: React.FC<SourceItemsColumnProps> = ({ value, alignRight, ...restProps }) => (
    <ActionLinkColumn
        content={value || ColumnTexts.DashSymbol}
        isLink={Boolean(value)}
        isExtMode={true}
        alignRight={alignRight}
        renderModal={({ deactivate }) => (
            <SourceItemsDialog
                {...restProps}
                deactivate={deactivate}
            />
        )}
    />
);

